var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SoliResponsiveDialog", {
    attrs: { persistent: "", title: "Attendance Notes", mobileScroll: false },
    on: {
      reset: function ($event) {
        return _setup.handleReset()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "subtitle",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                attrs: {
                  "x-small": "",
                  rounded: "",
                  outlined: "",
                  color: "accent",
                  href: `/profile/${_vm.student.id}/attendance?viewNotes=1`,
                },
              },
              [_vm._v("View All")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("v-container", [
              _c(
                "div",
                { staticClass: "flex flex-col gap-4 px-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-subtitle-2 font-weight-bold soli-grey",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            `What did you and ${_vm.student.first_name} work on?`
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(_setup.TipTapReader, {
                    attrs: { wrapper: "", value: _vm.lessonNote ?? "" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-subtitle-2 font-weight-bold soli-grey",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            `What should ${_vm.student.first_name} work on at home?`
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(_setup.TipTapReader, {
                    attrs: { wrapper: "", value: _vm.practiceNote ?? "" },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _setup.show,
      callback: function ($$v) {
        _setup.show = $$v
      },
      expression: "show",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }